import apiClient from '../axios';
import _ from "lodash";

export async function all(countryId) {
  return apiClient
    .get(`/country/${countryId}/places/all`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function list(countryId, page, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  if (!_.isEmpty(filter)) {

    return apiClient
      .post(`/country/${countryId}/places?page=${page}${sortingQuery}`, filter)
      .then(response => {
        if (response) {

          return response
        }
        return false
      })
      .catch(err => err && err);
  }

  return apiClient
    .get(`/country/${countryId}/places?page=${page}${sortingQuery}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}


export async function details(countryId, id) {
  return apiClient
    .get(`/country/${countryId}/places/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function add(data) {
  return apiClient
    .put(`/country/${data.countryId}/places`, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function edit(countryId, id, data) {
  return apiClient
    .post(`/country/${countryId}/places/${id}`, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function remove(countryId, id) {
  return apiClient
    .delete(`/country/${countryId}/places/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}
